import _typeof from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _classCallCheck from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import './captcha.less';
import Slider from './slider/slider';
import Rotate from './rotate/rotate';
import Concat from './concat/concat';
import WordImageClick from './word_image_click/word_image_click';
import { CaptchaConfig, wrapConfig, wrapStyle } from './config/config';
import { clearAllPreventDefault } from './common/common';
var template = "\n    <div id=\"tianai-captcha-parent\">\n        <!-- \u9876\u90E8-\u64CD\u4F5C\u6309\u94AE -->\n        <div class=\"slider-top\">\n            <div class=\"close-btn\" id=\"tianai-captcha-slider-close-btn\"></div>\n            <div class=\"refresh-btn\" id=\"tianai-captcha-slider-refresh-btn\"></div>\n        </div>\n        <div id=\"tianai-captcha-bg-img\"></div>\n        <div id=\"tianai-captcha-box\">\n            <div id=\"tianai-captcha-loading\" class=\"loading\"></div>\n        </div>\n        <!-- \u5E95\u90E8 -->\n<!--        <div class=\"slider-bottom\">-->\n<!--            <img class=\"logo\" id=\"tianai-captcha-logo\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAMFBMVEVHcEz3tkX3tkX3tkX3tkX3tkX3tkX3tkX3tkX3tkX3tkX3tkX3tkX3tkX3tkX3tkVmTmjZAAAAD3RSTlMASbTm8wh12hOGoCNiyTV98jvOAAABB0lEQVR42nVT0aIFEQiMorD0/397Lc5a7J0n1UylgIniLRKyDcbBDudZH2DYCAabn3PmTrjeUX+7rJGWx0SqVpzReAfTtKU5fgVCNfxWjB69USUDGwoOiauHpZEpSr0tCx8ILb3Dm3WgBbAlifAJk6+Ww6wqEUmpmIorQVZ1JtqKnDMjkb7AgIpO/wMCaQbuBuEtsBUxhuD9daUaZnApiQB8NAKotMwirGGr6mbXpPnHLHDmy6oy3FgP+1j8IBdVklFc01xUJwv3NR0rIeXV5zpzdlruiijzNq/ufOeKWzZLP3160u5P8RjT1M+HHFtx+PwGyOZqT/D8ROOfjOInTLBIHjy/hvwHxkwPu5cCE1QAAAAASUVORK5CYII=\" id=\"tianai-captcha-logo\"></img>-->\n<!--            <div class=\"close-btn\" id=\"tianai-captcha-slider-close-btn\"></div>-->\n<!--            <div class=\"refresh-btn\" id=\"tianai-captcha-slider-refresh-btn\"></div>-->\n<!--        </div>-->\n    </div>\n    ";
function createCaptchaByType(type, tac) {
  var box = tac.config.domBindEl.find('#tianai-captcha-box');
  var styleConfig = tac.style;
  switch (type) {
    case 'SLIDER':
      return new Slider(box, styleConfig);
    case 'ROTATE':
      return new Rotate(box, styleConfig);
    case 'CONCAT':
      return new Concat(box, styleConfig);
    case 'WORD_IMAGE_CLICK':
      return new WordImageClick(box, styleConfig);
    default:
      return null;
  }
}
var TianAiCaptcha = /*#__PURE__*/function () {
  function TianAiCaptcha(config, style) {
    _classCallCheck(this, TianAiCaptcha);
    this.config = wrapConfig(config);
    if (this.config.btnRefreshFun) {
      this.btnRefreshFun = this.config.btnRefreshFun;
    }
    if (this.config.btnCloseFun) {
      this.btnCloseFun = this.config.btnCloseFun;
    }
    this.style = wrapStyle(style);
  }
  return _createClass(TianAiCaptcha, [{
    key: "init",
    value: function init() {
      var _this = this;
      this.destroyWindow();
      this.config.domBindEl.append(template);
      this.domTemplate = this.config.domBindEl.find('#tianai-captcha-parent');
      clearAllPreventDefault(this.domTemplate);
      this.loadStyle();
      // 绑定按钮事件
      this.config.domBindEl.find('#tianai-captcha-slider-refresh-btn').click(function (el) {
        _this.btnRefreshFun(el, _this);
      });
      this.config.domBindEl.find('#tianai-captcha-slider-close-btn').click(function (el) {
        _this.btnCloseFun(el, _this);
      });
      // 加载验证码
      this.reloadCaptcha();
      return this;
    }
  }, {
    key: "btnRefreshFun",
    value: function btnRefreshFun(el, tac) {
      tac.reloadCaptcha();
    }
  }, {
    key: "btnCloseFun",
    value: function btnCloseFun(el, tac) {
      tac.destroyWindow();
    }
  }, {
    key: "reloadCaptcha",
    value: function reloadCaptcha() {
      var _this2 = this;
      this.showLoading();
      this.destroyCaptcha(function () {
        _this2.createCaptcha();
      });
    }
  }, {
    key: "showLoading",
    value: function showLoading() {
      this.config.domBindEl.find('#tianai-captcha-loading').css('display', 'block');
    }
  }, {
    key: "closeLoading",
    value: function closeLoading() {
      this.config.domBindEl.find('#tianai-captcha-loading').css('display', 'none');
    }
  }, {
    key: "loadStyle",
    value: function loadStyle() {
      // 设置样式
      var bgUrl = this.style.bgUrl;
      var logoUrl = this.style.logoUrl;
      if (bgUrl) {
        // 背景图片
        this.config.domBindEl.find('#tianai-captcha-bg-img').css('background-image', 'url(' + bgUrl + ')');
      }
      if (logoUrl && logoUrl !== '') {
        // logo
        this.config.domBindEl.find('#tianai-captcha-logo').attr('src', logoUrl);
      } else if (logoUrl === null) {
        // 删除logo
        if (this.config.domBindEl.find('#tianai-captcha-logo')) {
          this.config.domBindEl.find('#tianai-captcha-logo').css('display', 'none');
        }
      }
    }
  }, {
    key: "destroyWindow",
    value: function destroyWindow() {
      if (this.C) {
        this.C.destroy();
        this.C = undefined;
      }
      if (this.domTemplate) {
        this.domTemplate.remove();
      }
    }
  }, {
    key: "openCaptcha",
    value: function openCaptcha() {
      var _this3 = this;
      setTimeout(function () {
        _this3.C.el.css('transform', 'translateX(0)');
      }, 10);
    }
  }, {
    key: "createCaptcha",
    value: function createCaptcha() {
      var _this4 = this;
      this.config.requestCaptchaData().then(function (data) {
        _this4.closeLoading();

        // 添加更详细的调试信息
        console.log('=== 验证码接口调试信息 ===');
        console.log('1. 原始返回数据:', data);
        console.log('2. 数据类型:', _typeof(data));
        console.log('3. 是否为null:', data === null);
        console.log('4. 是否为undefined:', data === undefined);
        if (data && _typeof(data) === 'object') {
          console.log('5. 数据的所有键:', Object.keys(data));
          console.log('6. 数据的值:', Object.values(data));
          console.log('7. 完整数据结构:', JSON.stringify(data, null, 2));
        }

        // 检查数据结构
        if (!data) {
          throw new Error('[TAC] 验证码接口返回数据为空');
        }

        // 尝试适配更多种数据结构
        var captchaData = null;
        var captchaType = null;
        var captchaId = null;
        if (data.captcha && data.captcha.type) {
          // 标准结构：{ captcha: { type: "SLIDER", ... } }
          captchaData = data;
          captchaType = data.captcha.type;
          captchaId = data.id;
          console.log('✅ 检测到标准数据结构');
        } else if (data.type) {
          // 直接结构：{ type: "SLIDER", id: "xxx", ... }
          captchaData = {
            captcha: data
          };
          captchaType = data.type;
          captchaId = data.id;
          console.log('✅ 检测到直接数据结构，已自动适配');
        } else if (data.data && data.data.captcha && data.data.captcha.type) {
          // 嵌套结构：{ data: { captcha: { type: "SLIDER", ... }, id: "xxx" } }
          captchaData = data.data;
          captchaType = data.data.captcha.type;
          captchaId = data.data.id;
          console.log('✅ 检测到data.captcha嵌套数据结构，已自动适配');
        } else if (data.data && data.data.type) {
          // 嵌套结构：{ data: { type: "SLIDER", ... } }
          captchaData = {
            captcha: data.data
          };
          captchaType = data.data.type;
          captchaId = data.data.id;
          console.log('✅ 检测到data嵌套数据结构，已自动适配');
        } else if (data.result && data.result.captcha && data.result.captcha.type) {
          // result嵌套结构：{ result: { captcha: { type: "SLIDER", ... }, id: "xxx" } }
          captchaData = data.result;
          captchaType = data.result.captcha.type;
          captchaId = data.result.id;
          console.log('✅ 检测到result.captcha嵌套数据结构，已自动适配');
        } else if (data.result && data.result.type) {
          // result结构：{ result: { type: "SLIDER", ... } }
          captchaData = {
            captcha: data.result
          };
          captchaType = data.result.type;
          captchaId = data.result.id;
          console.log('✅ 检测到result数据结构，已自动适配');
        } else if (data.body && data.body.captcha && data.body.captcha.type) {
          // body嵌套结构：{ body: { captcha: { type: "SLIDER", ... }, id: "xxx" } }
          captchaData = data.body;
          captchaType = data.body.captcha.type;
          captchaId = data.body.id;
          console.log('✅ 检测到body.captcha嵌套数据结构，已自动适配');
        } else if (data.body && data.body.type) {
          // body结构：{ body: { type: "SLIDER", ... } }
          captchaData = {
            captcha: data.body
          };
          captchaType = data.body.type;
          captchaId = data.body.id;
          console.log('✅ 检测到body数据结构，已自动适配');
        } else if (data.content && data.content.captcha && data.content.captcha.type) {
          // content嵌套结构：{ content: { captcha: { type: "SLIDER", ... }, id: "xxx" } }
          captchaData = data.content;
          captchaType = data.content.captcha.type;
          captchaId = data.content.id;
          console.log('✅ 检测到content.captcha嵌套数据结构，已自动适配');
        } else if (data.content && data.content.type) {
          // content结构：{ content: { type: "SLIDER", ... } }
          captchaData = {
            captcha: data.content
          };
          captchaType = data.content.type;
          captchaId = data.content.id;
          console.log('✅ 检测到content数据结构，已自动适配');
        } else {
          // 尝试在所有属性中查找type字段
          console.log('🔍 在所有属性中查找type字段...');
          for (var key in data) {
            if (data[key] && _typeof(data[key]) === 'object') {
              // 检查直接的type字段
              if (data[key].type) {
                captchaData = {
                  captcha: data[key]
                };
                captchaType = data[key].type;
                captchaId = data[key].id;
                console.log("\u2705 \u5728 ".concat(key, " \u5C5E\u6027\u4E2D\u627E\u5230type\u5B57\u6BB5\uFF0C\u5DF2\u81EA\u52A8\u9002\u914D"));
                break;
              }
              // 检查嵌套的captcha.type字段
              if (data[key].captcha && data[key].captcha.type) {
                captchaData = data[key];
                captchaType = data[key].captcha.type;
                captchaId = data[key].id;
                console.log("\u2705 \u5728 ".concat(key, ".captcha \u5C5E\u6027\u4E2D\u627E\u5230type\u5B57\u6BB5\uFF0C\u5DF2\u81EA\u52A8\u9002\u914D"));
                break;
              }
            }
          }
          if (!captchaType) {
            console.error('❌ 无法识别的数据结构详情:');
            console.error('- 数据:', data);
            console.error('- 数据键:', Object.keys(data || {}));
            console.error('- 期望的字段: type (验证码类型)');
            console.error('- 支持的结构:');
            console.error('  1. {captcha: {type: "SLIDER", ...}, id: "xxx"}');
            console.error('  2. {type: "SLIDER", id: "xxx", ...}');
            console.error('  3. {data: {captcha: {type: "SLIDER", ...}, id: "xxx"}}');
            console.error('  4. {data: {type: "SLIDER", id: "xxx", ...}}');
            console.error('  5. {result: {captcha: {type: "SLIDER", ...}, id: "xxx"}}');
            console.error('  6. {result: {type: "SLIDER", id: "xxx", ...}}');
            console.error('  7. {body: {captcha: {type: "SLIDER", ...}, id: "xxx"}}');
            console.error('  8. {body: {type: "SLIDER", id: "xxx", ...}}');
            console.error('  9. {content: {captcha: {type: "SLIDER", ...}, id: "xxx"}}');
            console.error('  10. {content: {type: "SLIDER", id: "xxx", ...}}');
            throw new Error('[TAC] 验证码接口返回数据结构错误，无法找到type字段。请检查后端返回的数据结构。详细信息请查看控制台。');
          }
        }
        if (!captchaType) {
          console.error('[TAC] 数据结构错误，type字段为空:', captchaData);
          throw new Error('[TAC] 验证码接口返回数据结构错误，type字段为空');
        }

        // 确保captchaData中包含id字段
        if (captchaId && !captchaData.id) {
          captchaData.id = captchaId;
        }
        console.log('✅ 最终使用的验证码类型:', captchaType);
        console.log('✅ 最终使用的验证码ID:', captchaId);
        console.log('✅ 最终使用的验证码数据:', captchaData);
        console.log('=== 调试信息结束 ===');
        var captcha = createCaptchaByType(captchaType, _this4);
        if (captcha == null) {
          throw new Error('[TAC] 未知的验证码类型[' + captchaType + ']');
        }
        captcha.init(captchaData, function (d, c) {
          // 验证
          var currentCaptchaData = c.currentCaptchaData;
          var data = {
            bgImageWidth: currentCaptchaData.bgImageWidth,
            bgImageHeight: currentCaptchaData.bgImageHeight,
            templateImageWidth: currentCaptchaData.templateImageWidth,
            templateImageHeight: currentCaptchaData.templateImageHeight,
            startTime: currentCaptchaData.startTime,
            stopTime: currentCaptchaData.stopTime,
            trackList: currentCaptchaData.trackList
          };
          if (c.type === 'ROTATE_DEGREE' || c.type === 'ROTATE') {
            data.bgImageWidth = c.currentCaptchaData.end;
          }
          if (currentCaptchaData.data) {
            data.data = currentCaptchaData.data;
          }
          // 清空
          var id = c.currentCaptchaData.currentCaptchaId;
          c.currentCaptchaData = undefined;
          // 调用验证接口
          _this4.config.validCaptcha(id, data, c, _this4);
        });
        _this4.C = captcha;
        _this4.openCaptcha();
      }).catch(function (error) {
        _this4.closeLoading();
        console.error('[TAC] 验证码创建失败:', error);
        // 显示错误信息给用户
        alert('验证码加载失败: ' + error.message);
      });
    }
  }, {
    key: "destroyCaptcha",
    value: function destroyCaptcha(callback) {
      var _this5 = this;
      if (this.C) {
        this.C.el.css('transform', 'translateX(300px)');
        setTimeout(function () {
          _this5.C.destroy();
          if (callback) {
            callback();
          }
        }, 500);
      } else {
        callback();
      }
    }
  }]);
}();
export { TianAiCaptcha, CaptchaConfig };